var _metadata, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 16 32",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#030303",
    d: "M5 0h1M3 6h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020202",
    d: "M6 0h1M7 1h1M2 7h1M2 8h1M5 8h1M5 14h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#070707",
    d: "M4 1h1M3 14h1M6 14h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M6 1h1M4 2h1M4 3h1M6 3h1M5 4h2M4 5h2M5 6h1M5 7h1M1 9h1M5 9h2M1 10h1M3 10h1M5 10h1M7 10h1M1 11h1M3 11h1M5 11h1M8 11h1M1 12h1M5 12h1M2 13h1M7 13h1M4 14h1M5 15h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#010101",
    d: "M7 2h1M4 9h1M8 12h1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#262626",
    d: "M4 4h1M3 17h1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#060606",
    d: "M5 13h1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.9686274509803922)",
    d: "M2 16h2M5 16h1M2 17h1M5 17h1M3 18h2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreble);
export default __webpack_public_path__ + "static/media/treble.0268190cb081a5dd4c34b7c305b4984c.svg";
export { ForwardRef as ReactComponent };